import { getTokenApi, login, checkTicket } from '@/api/user'
import { actionTypes } from '@/store'

export const unLoginVerify = async ({ sdk, userInfo, appId, ticket, type, callBack }) => {
  const model: any = {
    type,
    sdk,
    appId: appId ?? undefined,
    ts: Date.now(),
  }

  if (ticket) {
    model.ticket = ticket
  } else if (userInfo) {
    model.userInfo = userInfo
  }

  const res = await login(model).catch(err => console.log(err))
  if (res?.code === 0) {
    res.data.userVos.map(option => {
      option.token = res.data.token
    })
    getToken(res.data.userVos[0], callBack)
  }
}

const getToken = async (model, callBack) => {
  const res = await getTokenApi(model)
  if (res?.code === 0) {
    localStorage.setItem('token', res.data.token);
    sessionStorage.setItem('unlogin', 'yes');
    callBack({ type: actionTypes.SET_USER, payload: { isLogin: true } });
  }
  return res
}

export const getUserCenterToken = async (ticket: string, gui: string, callBack: any) => {
  const ucCode = localStorage.getItem('ucCode')
  const params: any = { ucCode, ticket }
  if (gui) {
    params.userInfo = gui
  }
  const res = await checkTicket(params)
  if (res?.code === 0) {
    localStorage.setItem('token', res.data);
    callBack({ type: actionTypes.SET_USER, payload: { isLogin: true } });
  }
}